/* global toastr */
import React from 'react'
import { PROJECT_NAME } from "./constants"
import { wrapView } from '../smart_bps/lib/utils'
import { stateToProps } from '../smart_bps/bps/base_view'
import { request, uploadFile } from "../smart_bps/lib/utils"
import { LoginView } from "../smart_bps/auth/login"
import { Link } from "react-router-dom"
import { SigurPopover } from '../lib/SigurPopover'

const EMAIL_EXISTS_MSG = 'Пользователь с таким email уже есть в системе'

class ContractorRegistrationView extends LoginView {
  constructor(props) {
    super(props);
    this.state = {
      formIsSend: false,
      RegisterContractorForm: {
        company_name: '',
        inn: '',
        note: '',
        role_ids: [],
        files: {}
      },
      RegisterContractorFormErrors: {},
      phoneDisplay: '',
      users: [{
        lastName: '',
        firstName: '',
        position: '',
        phone: '',
        email: '',
        phoneDisplay: '',
        role_ids: [],
      }],
      usersErrors: {},
      meta: {
        availableRoles: [],
        filetypesData: [],
        requiredFiletypes: []
      }
    };

    this.loadMeta = this.loadMeta.bind(this)
    this.checkUserEmailOnBlur = this.checkUserEmailOnBlur.bind(this)
  }

  setFormField = (field, value) => {
    this.setState(prev => ({
      RegisterContractorForm: {
        ...prev.RegisterContractorForm,
        [field]: value
      }
    }))
  }

  setStateField = (field, value) => {
    this.setState({
      [field]: typeof value === 'function'
        ? value(this.state[field])
        : value
    })
  }

  loadMeta() {
    request({
      method: 'get',
      url: `/api/${PROJECT_NAME}/contract_registration_meta`,
      success: (data) => {
        this.setState({
          meta: data
        })
      },
    })
  }


  handleFileSelect = (e, filetype) => {
    const file = e.target.files?.[0]
    if (!file) return

    const currentFiles =
      this.state.RegisterContractorForm.files[filetype] || []

    const updatedFiles = {
      ...this.state.RegisterContractorForm.files,
      [filetype]: [
        ...currentFiles,
        {
          id: crypto.randomUUID(),
          file,
          title: file.name,
          filetype: filetype
        },
      ],
    }

    this.setFormField('files', updatedFiles)

    e.target.value = ''
  }

  removeFile = (filetype, fileId) => {
    const filesByType = this.state.RegisterContractorForm.files || {}

    const updatedFiles = {
      ...filesByType,
      [filetype]: (filesByType[filetype] || []).filter(
        file => file.id !== fileId
      ),
    }
    this.setFormField('files', updatedFiles)
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.submitForm()
  }

  isValidEmailFormat = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || '').trim())

  setUserEmailExistsError = (index, exists) => {
    this.setState((prev) => {
      const usersErrors = { ...prev.usersErrors }
      const row = { ...(usersErrors[index] || {}) }
      if (exists) {
        row.emailExists = true
        usersErrors[index] = row
      } else if (row.emailExists) {
        delete row.emailExists
        if (Object.keys(row).length > 0) {
          usersErrors[index] = row
        } else {
          delete usersErrors[index]
        }
      }
      return { usersErrors }
    })
  }

  checkUserEmailOnBlur = (index, email) => {
    const trimmed = (email || '').trim()
    if (!trimmed || !this.isValidEmailFormat(trimmed)) {
      this.setUserEmailExistsError(index, false)
      return
    }

    request({
      method: 'get',
      url: `/api/auth/check_user_email?email=${encodeURIComponent(trimmed)}`,
      success: (data) => {
        this.setUserEmailExistsError(index, Boolean(data.exists))
      },
    })
  }

  validateEmailsUnique = (users) => {
    const seen = new Set()
    const checks = users.map((user, index) => {
      const trimmed = (user.email || '').trim()
      if (!trimmed || !this.isValidEmailFormat(trimmed)) {
        return Promise.resolve({ index, exists: false })
      }
      const key = trimmed.toLowerCase()
      if (seen.has(key)) {
        return Promise.resolve({ index, exists: true })
      }
      seen.add(key)
      return new Promise((resolve) => {
        request({
          method: 'get',
          url: `/api/auth/check_user_email?email=${encodeURIComponent(trimmed)}`,
          success: (data) => resolve({ index, exists: Boolean(data.exists) }),
          error: () => resolve({ index, exists: false }),
        })
      })
    })

    return Promise.all(checks).then((results) => {
      let hasError = false
      results.forEach(({ index, exists }) => {
        if (exists) {
          hasError = true
          this.setUserEmailExistsError(index, true)
        }
      })
      return !hasError
    })
  }

  applyRegisterEmailErrors = (detail) => {
    if (!detail?.user_email_errors) return false
    const usersErrors = { ...this.state.usersErrors }
    Object.entries(detail.user_email_errors).forEach(([idx]) => {
      const index = Number(idx)
      usersErrors[index] = { ...(usersErrors[index] || {}), emailExists: true }
    })
    this.setState({ usersErrors })
    return true
  }

  submitForm = async () => {
    const form = this.state.RegisterContractorForm
    const users = this.state.users
    const hasContractorErrors = this.hasContractorErrors(form)
    const hasUsersErrors = this.hasUsersErrors(users)

    if (hasContractorErrors || hasUsersErrors) {
      return
    }

    const emailsOk = await this.validateEmailsUnique(users)
    if (!emailsOk) {
      return
    }

    const data = {
      company_name: form.company_name,
      inn: form.inn,
      note: form.note,

      users: users.map(user => ({
        last_name: user.lastName,
        first_name: user.firstName,
        position: user.position,
        phone: user.phone,
        email: user.email,
        role_ids: user.role_ids || []
      }))
    }

    request({
      method: 'post',
      url: '/api/auth/register_contractor',
      data: data,
      success: (data) => {
        Object.entries(form.files).forEach(([file_type, file_items]) => {
          file_items.forEach((file_item) => {
              uploadFile({
                file_item: file_item.file,
                url: `/api/auth/contract_reg_upload_file/${data.task_id}`,
                form_args: { file_type: file_type },
              })
          })
        })
        this.setState({ formIsSend:true })
      },
      error: (err) => {
        const detail = err?.detail
        if (!this.applyRegisterEmailErrors(detail)) {
          const msg = typeof detail === 'string' ? detail : 'Не удалось отправить форму'
          toastr.error(msg)
        }
      },
    })
  }

  hasContractorErrors = (form) => {
    const errors = this.validateForm(form)
    return Object.keys(errors).length > 0
  }

  validateForm = (form) => {
    const { RegisterContractorForm, meta } = this.state
    const errors = {}
    const uploadedFiletypesSet = new Set(Object.keys(RegisterContractorForm.files))
    const requiredFiletypesSet = new Set(meta.requiredFiletypes)
    const missingFiletypes = [...requiredFiletypesSet].filter(type => !uploadedFiletypesSet.has(type))

    const defaultErrorMessage = 'Проверьте на корректность введенные данные'
    const inn = (form.inn || '').trim()

    if (!inn) {
      errors.inn = defaultErrorMessage
      toastr.error('Заполните все обязательные поля перед отправкой формы.')
    }

    if (missingFiletypes.length) {
      toastr.error('Загрузите все обязательные файлы перед отправкой формы.')
    }

    const innLen = inn.length
    if (inn && innLen !== 10 && innLen !== 12) {
      errors.inn = defaultErrorMessage
    }

    missingFiletypes.forEach((filetype) => {
      errors[filetype] = defaultErrorMessage
    })

    this.setState({
      RegisterContractorFormErrors: errors,
    })

    return errors
  }

  addUser = () => {
    this.setStateField('users', prev => [
      ...(prev || []),
      {
        lastName: '',
        firstName: '',
        position: '',
        phone: '',
        email: '',
        phoneDisplay: '',
        role_ids: [],
      }
    ])
  }

  removeUser = (index) => {
    this.setStateField('users', prev =>
      prev.filter((_, i) => i !== index)
    )
  }

  updateUser = (index, field, value) => {
    this.setStateField('users', prev =>
      prev.map((user, i) =>
        i === index ? { ...user, [field]: value } : user
      )
    )
    if (field === 'email') {
      this.setUserEmailExistsError(index, false)
    }
  }

  updateUserPhone = (index, value) => {
    let digits = value.replace(/\D/g, '').slice(0, 11)

    if (digits.length > 0 && digits[0] !== '7') {
      digits = '7' + digits.slice(1)
    }

    let display = '+7'
    if (digits.length > 1) display += ' (' + digits.slice(1, 4)
    if (digits.length >= 4) display += ') ' + digits.slice(4, 7)
    if (digits.length >= 7) display += '-' + digits.slice(7, 9)
    if (digits.length >= 9) display += '-' + digits.slice(9, 11)

    this.setStateField('users', prev =>
      prev.map((user, i) =>
        i === index
          ? { ...user, phone: digits, phoneDisplay: display }
          : user
      )
    )
  }

  hasUsersErrors = (users) => {
    const errors = this.validateUsers(users)
    return Object.keys(errors).length > 0
  }

  validateUsers = (users) => {
    const errors = {}

    users.forEach((user, index) => {
      const userErrors = {}

      const requiredFields = ['lastName', 'firstName', 'position', 'email', 'role_ids']
      requiredFields.forEach(field => {
        const value = user[field]

        const isEmpty =
          Array.isArray(value)
            ? value.length === 0
            : typeof value === 'string'
              ? value.trim() === ''
              : value == null

        if (isEmpty) {
          userErrors[field] = true
        }
      })

      if (
        user.email &&
        (
          !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.email) ||
          /[^\x00-\x7F]/.test(user.email)
        )
      ) {
        userErrors.emailFormat = true
      }

      if (Object.keys(userErrors).length > 0) {
        errors[index] = userErrors
      }
    })

    if (Object.keys(errors).length > 0) {
      toastr.error("Заполните все обязательные поля для всех пользователей.")
    }

    this.setState({
      usersErrors: errors,
    })

    return errors
  }

  componentDidMount() {
    this.loadMeta()
  }

  renderSection(num, title, desc, children) {
    return (
      <section className="sigur-register__section">
        <div className="sigur-register__section-head">
          <div className="sigur-register__section-num-col">
            <span className="sigur-register__section-num" aria-hidden>{num}</span>
          </div>
          <div className="sigur-register__section-head-text">
            <h2 className="sigur-register__section-title">{title}</h2>
            {desc ? <p className="sigur-register__section-desc">{desc}</p> : null}
          </div>
        </div>
        {children}
      </section>
    )
  }

  renderSuccess() {
    return (
      <div className="sigur-register-page">
        <div className="sigur-register sigur-register--success">
          <div className="sigur-register__success">
            <span className="sigur-register__success-icon" aria-hidden>
              <i className="ti ti-circle-check" />
            </span>
            <h1 className="sigur-register__success-title">Заявка отправлена</h1>
            <p className="sigur-register__success-text">
              Заявка на регистрацию принята. После обработки на указанную почту придёт письмо с дальнейшими инструкциями.
            </p>
            <Link to="/" className="sigur-register__submit sigur-register__submit--inline">
              На главную
            </Link>
          </div>
        </div>
      </div>
    )
  }

  renderHeaderBlock() {
    return (
      <header className="sigur-register__hero">
        <Link to="/" className="sigur-register__back">
          <i className="ti ti-arrow-left" aria-hidden />
          На главную
        </Link>
        <p className="sigur-register__hero-kicker">Sigur · Регистрация контрагента</p>
        <h1 className="sigur-register__hero-title">
          Заявка на подключение к системе согласования заявок на доступ
        </h1>
        <p className="sigur-register__hero-lead">
          Укажите данные организации, добавьте сотрудников и приложите документы — мы рассмотрим заявку и откроем доступ.
        </p>
      </header>
    )
  }

  renderOrganizationBlock() {
    const formErrors = this.state.RegisterContractorFormErrors || {}
    return this.renderSection(
      '01',
      'Данные организации',
      'Идентификатор и наименование контрагента для создания учётной записи',
      (
        <div className="row g-3">
          <div className="col-md-4">
            <label className="form-label">
              ИНН <span className="required-asterisk">*</span>
            </label>
            <input
              type="text"
              className={`form-control ${formErrors.inn ? 'sigur-register_form-control-error' : ''}`}
              placeholder="10 или 12 цифр"
              value={this.state.RegisterContractorForm.inn}
              onKeyDown={(e) => {
                if (['+', '-'].includes(e.key)) e.preventDefault()
              }}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, '')
                this.setFormField('inn', value)
              }}
              maxLength="12"
            />
            {formErrors.inn ? (
              <div className="sigur-register__field-error">{formErrors.inn}</div>
            ) : null}
          </div>
          <div className="col-md-8">
            <label className="form-label">
              Полное наименование организации (по ЕГРЮЛ/ЕГРИП)
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Общество с ограниченной ответственностью «Пример»"
              value={this.state.RegisterContractorForm.company_name}
              onChange={(e) => this.setFormField('company_name', e.target.value)}
            />
          </div>
        </div>
      ),
    )
  }

  renderUserBlock() {
    const userCnt = this.state.users.length
    const { usersErrors } = this.state

    return this.renderSection(
      '02',
      'Пользователи',
      'Сотрудники, которым нужен доступ к системе — для каждого укажите контакты и роли',
      (
        <>
        {this.state.users.map((user, index) => (
          <div key={index} className="sigur-register__user-card">
            {userCnt > 1 ? (
              <div className="sigur-register__user-head">
                <span className="sigur-register__user-label">Пользователь {index + 1}</span>
                <button
                  type="button"
                  className="sigur-register__remove-btn"
                  onClick={() => this.removeUser(index)}
                >
                  <i className="ti ti-trash" aria-hidden />
                  Удалить
                </button>
              </div>
            ) : null}

            <div className="row g-3 mb-0">
              <div className="col-md-6">
                <label className="form-label">
                  Фамилия <span className="required-asterisk">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${usersErrors[index]?.lastName ? 'sigur-register_form-control-error' : ''}`}
                  value={user.lastName}
                  onChange={(e) => this.updateUser(index, 'lastName', e.target.value)}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  Имя <span className="required-asterisk">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${usersErrors[index]?.firstName ? 'sigur-register_form-control-error' : ''}`}
                  value={user.firstName}
                  onChange={(e) => this.updateUser(index, 'firstName', e.target.value)}
                />
              </div>
            </div>

            <div className="row g-3 mt-0">
              <div className="col-md-6">
              <label className="form-label">
                Должность <span className="required-asterisk">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${usersErrors[index]?.position ? 'sigur-register_form-control-error' : ''}`}
                value={user.position}
                onChange={(e) => this.updateUser(index, 'position', e.target.value)}
              />
              </div>

              <div className="col-md-6">
              <label className="form-label">
                Телефон
              </label>
              <input
                type="text"
                className={`form-control ${usersErrors[index]?.phone ? 'sigur-register_form-control-error' : ''}`}
                placeholder="+7 (___) ___-__-__"
                value={user.phoneDisplay}
                onChange={(e) => this.updateUserPhone(index, e.target.value)}
              />
              </div>
            </div>

            <div className="mt-3">
              <label className="form-label">
                Электронная почта (для входа в систему) <span className="required-asterisk">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${usersErrors[index]?.email || usersErrors[index]?.emailFormat || usersErrors[index]?.emailExists ? 'sigur-register_form-control-error' : ''}`}
                placeholder="example@company.ru"
                value={user.email}
                onChange={(e) => this.updateUser(index, 'email', e.target.value)}
                onBlur={(e) => this.checkUserEmailOnBlur(index, e.target.value)}
              />
              {usersErrors[index]?.emailFormat ? (
                <div className="sigur-register__field-error">Неверный формат электронной почты</div>
              ) : null}
              {usersErrors[index]?.emailExists ? (
                <div className="sigur-register__field-error">{EMAIL_EXISTS_MSG}</div>
              ) : null}
            </div>
            <div className="mt-3 mb-0">
              <label className="form-label">
                Доступный функционал (выберите хотя бы один) <span className="required-asterisk">*</span>
              </label>
              <div className="sigur-register_multiple-choice">
                {this.state.meta.availableRoles.map(([id, label]) => (
                  <label
                    key={id}
                    className={`sigur-register_multiple-choice__item ${usersErrors[index]?.role_ids ? 'sigur-register_form-control-error' : ''}`}
                  >
                    <input
                      type="checkbox"
                      value={id}
                      checked={user.role_ids.includes(id)}
                      onChange={(e) => {
                        const selectedId = parseInt(e.target.value);
                        let newRoles = [...user.role_ids];

                        if (e.target.checked) {
                          newRoles.push(selectedId);
                        } else {
                          newRoles = newRoles.filter(roleId => roleId !== selectedId);
                        }

                        this.updateUser(index, 'role_ids', newRoles);
                      }}
                    />
                    <span className="sigur-register_multiple-choice__label">{label}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>
        ))}

        <button
          type="button"
          className="sigur-register__add-btn"
          onClick={this.addUser}
        >
          <i className="ti ti-plus" aria-hidden />
          Добавить пользователя
        </button>
        </>
      ),
    )
  }

  renderFile = (item) => {
    return (
      <div
        key={item.id}
        className="sigur-files__file-row"
      >
        <div className="sigur-files__file-thumb-wrap">
          <span
            className="ti ti-file-description sigur-files__file-icon"
            aria-hidden
          />
        </div>

        <div className="sigur-files__file-info">
          <span
            className="sigur-files__file-name"
            title={item.title}
          >
            {item.title}
          </span>
        </div>

        <div className="sigur-files__file-actions">
          <button
            type="button"
            className="sigur-files__file-btn"
            onClick={() => this.removeFile(item.filetype, item.id)}
            title="Удалить"
          >
            <i className="ti ti-trash" aria-hidden />
          </button>
        </div>
      </div>
    )
  }

  renderFilesBlock() {
    return this.renderSection(
      '03',
      'Документы',
      'Загрузите файлы по типам — обязательные отмечены значком',
      (
          <div className="sigur-files-simple sigur-register__files">
            {this.state.meta.filetypesData.map((filetype_data) => {
              const requiredBadge = filetype_data.is_required ? (
                <span
                  className="ms-2 d-inline-flex align-items-center"
                  onMouseEnter={() => this.setState({ requiredPopoverKey: filetype_data.filetype })}
                  onMouseLeave={() => this.setState({ requiredPopoverKey: null })}
                >
                  <SigurPopover
                    placement="top"
                    visible={this.state.requiredPopoverKey === filetype_data.filetype}
                    trigger={
                      <span className="text-danger d-inline-flex align-items-center lh-1" aria-label="Обязательный документ">
                        <i className="ti ti-alert-circle lh-1" aria-hidden />
                      </span>
                    }
                  >
                    Обязательный документ
                  </SigurPopover>
                </span>
              ) : null
              const sectionFiles = this.state.RegisterContractorForm.files[filetype_data.filetype] || []
              const fileBlock = sectionFiles.length > 0 ? (
                <div className="sigur-files__list">
                  {sectionFiles.map(this.renderFile)}
                </div>
              ) : null

              return (
                <div
                  key={filetype_data.filetype}
                  className="sigur-files__section"
                >
                  <div
                    className={`sigur-files__section-header ${
                      this.state.RegisterContractorFormErrors?.[filetype_data.filetype]
                        ? 'sigur-warning-board'
                        : ''
                    }`}
                  >
                    <div className="sigur-files-simple__title">
                      <span className="sigur-files__section-title d-inline-flex align-items-center text-break">
                        {filetype_data.title}
                        {requiredBadge}
                      </span>

                    </div>
                    <label className="sigur-files__upload-btn">
                      <i className="ti ti-upload me-1" />
                      Загрузить файл

                      <input
                        type="file"
                        className="d-none"
                        onChange={(e) => this.handleFileSelect(e, filetype_data.filetype)}
                      />
                    </label>
                  </div>
                  <div>
                    {fileBlock}
                  </div>
                </div>
              )
            })}
          </div>
      ),
    )
  }

  renderAdditionalBlock() {
    return this.renderSection(
      '04',
      'Дополнительно',
      null,
      (
        <div>
          <label className="form-label">Примечание</label>
          <textarea
            className="form-control form-control-custom"
            rows="3"
            placeholder="Дополнительная информация для рассмотрения заявки"
            value={this.state.RegisterContractorForm.note}
            onChange={(e) => this.setFormField('note', e.target.value)}
          />
        </div>
      ),
    )
  }

  renderSubmitBar() {
    return (
      <div className="sigur-register__submit-bar">
        <button type="submit" className="sigur-register__submit">
          <i className="ti ti-send" aria-hidden />
          Отправить заявку
        </button>
      </div>
    )
  }

  render() {
    if (this.state.formIsSend) {
      return this.renderSuccess()
    }
    return (
      <div className="sigur-register-page">
        <div className="sigur-register">
          <form onSubmit={this.handleSubmit} className="sigur-register__form">
            {this.renderHeaderBlock()}
            <div className="sigur-register__body">
              {this.renderOrganizationBlock()}
              {this.renderUserBlock()}
              {this.renderFilesBlock()}
              {this.renderAdditionalBlock()}
            </div>
            {this.renderSubmitBar()}
          </form>
        </div>
      </div>
    )
  }
}

export default wrapView(ContractorRegistrationView, (state) => {
  return stateToProps(state, PROJECT_NAME)
})